import { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { DATA_SOURCES_PATH, LEGACY_INTEGRATIONS_PATH, TICKETING_SYSTEMS_PATH } from './integrationPaths'

const APPLICATIONS_SEGMENT = '/applications'

/* Keeps links to the old /settings/integrations addresses working, deep setup links included. */
const LegacyIntegrationsRedirect: FC = () => {
  const { pathname, search } = useLocation()
  const rest = pathname.slice(LEGACY_INTEGRATIONS_PATH.length)

  /* Both sections live under the legacy root, so an address already in one of them is a depth the
   * routes do not cover. Sending it on would only prefix the section again. */
  const section = [DATA_SOURCES_PATH, TICKETING_SYSTEMS_PATH].find((path) => pathname.startsWith(`${path}/`))

  const rewritten = rest.startsWith(APPLICATIONS_SEGMENT)
    ? `${TICKETING_SYSTEMS_PATH}${rest.slice(APPLICATIONS_SEGMENT.length)}`
    : `${DATA_SOURCES_PATH}${rest}`

  const target = section ?? rewritten

  return <Navigate to={`${target}${search}`} replace />
}

export default LegacyIntegrationsRedirect
